import { Field, ErrorMessage } from 'formik';

const AddrLine2 = ({ loading }) => {
  return (
    <div>
      <label htmlFor='addr_line_2'>
        Address Line 2
      </label>

      <Field
        id='addr_line_2'
        aria-label='address line 2'
        name='addr_line_2'
        type='text'
        disabled={loading}
      />

      <ErrorMessage
        name='addr_line_2'
        component='div'
      />
    </div>
  );
};

export default AddrLine2;